import React from "react";
import EventFeatureSkeleton from "./skeleton/EventFeatureSkeleton";
import Slider from "components/UI/Slider";
import styles from "./EventFeature.module.css";
import placeholder1000x625 from "assets/placeholder/1000x625.png";

const EventFeature = ({ features, loading, title }) => {

  if (loading || !features) {
    return <EventFeatureSkeleton />;
  }

  return (
    <div className={styles.Features}>
      <h2 className={styles.Title}> {title}</h2>

      <Slider>
        {features.map((item, index) => (
          <div key={index}>   
             <div className={styles.Item} >
               <img src={item || placeholder1000x625} alt="event" className="img-fluid" />
             </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default EventFeature;
